import { AppRoute, MenuStage, NavigationLinkBase } from '@ebeihilfe/core';
import { Injectable } from '@angular/core';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';

@Injectable()
export class ImprintNavLink extends NavigationLinkBase {
  public allowedStages = MenuStage.INIT;

  constructor() {
    super('IMPRESSUM', _('label.imprint'), AppRoute.InfoImprint, _('a11y.link.imprint'), 'ABOUT');
  }
}
